import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EnumerationService} from '../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../misc/exg-tab-v2/exg-tab-v2.component';
import {ApplicationService} from '../services/application.service';
import {DataService} from '../services/data.service';

@Component({
  selector: 'app-layoutdesigner',
  templateUrl: './layoutdesigner.component.html'
})
export class LayoutdesignerComponent extends ExcTranslation implements OnInit  {
  @Input()
  mainTable: any = [];
  @Input()
  uiFilter: any = [];
  @Input()
  uiSort: any = [];

  @ViewChild('VCrightTabControl', { read: ExgTabV2Component })
  VCrightTabControl!: ExgTabV2Component;

  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  controller = {
    tables: this.enumSvc.getEnumerationList('LayoutTable'),
    format: {
      cell:  {
        position: this.enumSvc.getEnumerationList('LayoutCellPosition'),
        alignment: this.enumSvc.getEnumerationList('LayoutCellAlignment'),
        value: this.enumSvc.getEnumerationList('LayoutCellValueFormatstring'),
      }
    },
    enumerations: this.enumSvc.getEnumerationList('LayoutTable'),
  };

  constructor(
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalSvc: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    const SELF = this;
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getRessource('Tabelle');
        }, icon_class: 'fal fa-table'
      }, {
        get caption(): string {
          return SELF.getRessource('Filter');
        }, icon_class: 'fal fa-filter'
      }, {
        get caption(): string {
          return SELF.getRessource('Sortierung');
        }, icon_class: 'fal fa-sort-alt'
      }, {
        get caption(): string {
          return SELF.getResource('Ansichten');
        }, icon_class: 'fal fa-eye'
      }
    ];
  }

  initTables(): void {

  }

  initEnumerations(): void {

  }

  rightTabs_tabChange(event: number): void {
  }

  action(): void {

  }
}
